import React from "react";
import { useNavigate } from "react-router-dom";
import { useGarmentMeasurementServiceContext } from "../../../contexts/GarmentMeasurementServiceContext";
import MainButton from "../../button/MainButton";
import { ArrowLeft, ArrowRight, Refresh2 } from "iconsax-react";
import Loader from "../../loading/Loader";

interface PaginationProps {
  handlerButtonText?: string;
  isMeasurementSuccessed?: boolean;
}

const GarmentMeasurementServicePagination: React.FC<PaginationProps> = ({ handlerButtonText = "Continue", isMeasurementSuccessed = false }) => {
  const { resetGarmentMeasurementService, canProceedToNextStep, currentStep, handlePageChange, loading } = useGarmentMeasurementServiceContext();

  const navigate = useNavigate();

  const handlePrevPage = () => {
    if (currentStep > 0) {
      handlePageChange(isMeasurementSuccessed ? currentStep - 2 : currentStep - 1);
    }
  };

  const handleNextPage = () => {
    if (isMeasurementSuccessed) {
      resetGarmentMeasurementService();
      navigate("/dashboard/free-trial/garment-measurement");
      return;
    }

    if (currentStep < 2 && canProceedToNextStep) {
      handlePageChange(currentStep + 1);
    }
  };

  return (
    <div className="flex justify-between w-full gap-4">
      {currentStep !== 2 ? (
        <MainButton type="secondary" onClick={handlePrevPage} disabled={currentStep === 0 || loading}>
          <ArrowLeft variant="Broken" />
          Previous
        </MainButton>
      ) : (
        <div></div>
      )}

      <MainButton type="primary" onClick={handleNextPage} disabled={!canProceedToNextStep || loading}>
        {loading ? (
          <div className="flex items-center gap-2">
            <span>Processing</span>
            <Loader size="sm" />
          </div>
        ) : (
          <>
            {handlerButtonText}
            {isMeasurementSuccessed ? <Refresh2 variant="Broken" /> : <ArrowRight variant="Broken" />}
          </>
        )}
      </MainButton>
    </div>
  );
};

export default GarmentMeasurementServicePagination;
